// ===========================================
// "Go to Class Pricing" link for the missing-price error
// ===========================================
// Admin routes live under the school slug (`/:schoolSlug/admin/...`). Both invoice
// dialogs linked to the bare admin pricing path (no slug), which 404'd for
// MNM (reported 2026-09-25). The slug comes from the current URL, the same way the
// admin pages build their base path (LessonsPage, LessonDetailPage, AdminLayout).

import { Link } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { extractSchoolSlugFromPath } from '../../utils/routing';
import { useLinkTargetProps } from './linkTarget';

export default function ClassPricingLink() {
  const { pathname } = useLocation();
  const schoolSlug = extractSchoolSlugFromPath(pathname);
  const slugPrefix = schoolSlug ? `/${schoolSlug}` : '';
  const target = useLinkTargetProps();

  return (
    <Link component={RouterLink} to={`${slugPrefix}/admin/pricing-config`} {...target}>
      Go to Class Pricing to add them
    </Link>
  );
}
